import type { ChatConversation } from '@/entities/chat'
import { useChatDockControls } from './useChatDockControls'

function findNextUnreadId(conversations: ChatConversation[], currentId: number | null): number | null {
  if (conversations.length === 0) return null
  const currentIndex = currentId == null ? -1 : conversations.findIndex((conversation) => conversation.id === currentId)
  const startIndex = currentIndex === -1 ? 0 : currentIndex + 1

  for (let offset = 0; offset < conversations.length; offset += 1) {
    const index = (startIndex + offset) % conversations.length
    const candidate = conversations[index]
    if (candidate.hasUnread && candidate.id !== currentId) return candidate.id
  }

  return null
}

export function useNextUnread(
  conversations: ChatConversation[],
  currentId: number | null,
): { nextUnreadId: number | null; goNext: () => void } {
  const { selectConversation } = useChatDockControls()
  const nextUnreadId = findNextUnreadId(conversations, currentId)

  const goNext = () => {
    if (nextUnreadId != null) selectConversation(nextUnreadId)
  }

  return { nextUnreadId, goNext }
}
